import { Routes, Route } from "react-router-dom";

import Login from "./pages/users/LoginPage";
import RecoverPasswordPage from "./pages/users/RecoverPasswordPage";
import ActivationAccountPage from "./pages/users/ActivationAccountPage";
import NotFound from "./pages/global/NotFoundPage";
import SessionExpiredModal from "./components/global/SessionExpiredModal";
import PrivateRoute from "./routes/PrivateRoute";
import Layout from "./components/global/Layout";
import { LayoutProvider } from "./context/LayoutContext";
import { protectedPageRoutes } from "./routes/protectedPageRoutes";

function AppRoutes() {

    return (
        <LayoutProvider>
            <SessionExpiredModal />
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/recover-password" element={<RecoverPasswordPage />} />
                <Route path="/:id/activate-account" element={<ActivationAccountPage type="ACTIVATION_ACCOUNT" />} />
                <Route path="/:id/reset-password" element={<ActivationAccountPage type="RESET_PASSWORD" />} />
                <Route element={<PrivateRoute />}>
                    <Route element={<Layout />}>
                        {protectedPageRoutes.map(({ path, element }) => (
                            <Route key={path} path={path} element={element} />
                        ))}
                        <Route path="*" element={<NotFound />} />
                    </Route>
                </Route>
            </Routes>
        </LayoutProvider>
    );
}

export default AppRoutes;
